import { Modal } from 'antd';
import i18n from '../../i18n';
import { estAdversaireBlesse } from '../../variables/constants';

/* ─────────────────────────────────────────────────────────────────────────
   Même personne saisie deux fois : une fois en partie adverse, une fois en
   victime (observation métier CB-01, octobre 2026).

   Une partie adverse blessée ou décédée est déjà une victime à indemniser
   (`estVictimeIndemnisable`). La ressaisir comme victime la faisait compter
   deux fois - maturité, bloc corporel, offres. Rien ne l'empêchait.

   On ne compare que le nom et les prénoms : les parties adverses saisies avant
   le 15/09/2026 portent une date de naissance inventée (le jour de la saisie).
   ───────────────────────────────────────────────────────────────────────── */

const identite = (p) => [p?.nom, p?.prenoms]
  .filter(Boolean).join(' ')
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toUpperCase().replace(/\s+/g, ' ').trim();

/** La fiche, parmi `fiches`, qui porte la même identité dans l'AUTRE rôle - sinon null. */
export const memePersonneAutreRole = (personne, fiches = []) => {
  const cle = identite(personne);
  if (!cle) return null;
  const adverse = !!personne?.estAdversaire;
  return fiches.find((f) => !!f?.estAdversaire !== adverse && identite(f) === cle) || null;
};

/**
 * Demande confirmation avant de créer le doublon. Résout `true` pour créer quand
 * même (deux homonymes distincts restent possibles), `false` pour renoncer.
 */
export const confirmerDoublonPersonne = (deja, nouvelle) => new Promise((resolve) => {
  const nom = [deja.nom, deja.prenoms].filter(Boolean).join(' ');
  const raison = nouvelle?.estAdversaire ? 'dejaVictime'
    : estAdversaireBlesse(deja) ? 'dejaAdversaireAtteint' : 'dejaAdversaire';
  Modal.confirm({
    title: i18n.t('commun:doublonPersonne.titre', { nom }),
    content: i18n.t(`commun:doublonPersonne.${raison}`),
    okText: i18n.t('commun:doublonPersonne.creerQuandMeme'),
    cancelText: i18n.t('commun:doublonPersonne.annuler'),
    onOk: () => resolve(true),
    onCancel: () => resolve(false),
  });
});
